export const mutation_add_user_permission = `
mutation addUserPermission($userId: String!, $aziendaId: Int!, $area: String!, $canRead: Boolean!, $canCreate: Boolean!, $canUpdate: Boolean!, $canDelete: Boolean!) {
    insert_user_permission_one(object: {UserId: $userId, AziendaId: $aziendaId, Area: $area, CanRead: $canRead, CanCreate: $canCreate, CanUpdate: $canUpdate, CanDelete: $canDelete}) {
        Id
        AziendaId
        Area
        CanRead
        CanCreate
        CanUpdate
        CanDelete
    }
}`;
export const mutation_update_user_permission = `
mutation updateUserPermission($id: Int!, $userId: String!, $aziendaId: Int!, $canRead: Boolean!, $canCreate: Boolean!, $canUpdate: Boolean!, $canDelete: Boolean!) {
    update_user_permission(where: {Id: {_eq: $id}, UserId: {_eq: $userId}, AziendaId: {_eq: $aziendaId}}, _set: {CanRead: $canRead, CanCreate: $canCreate, CanUpdate: $canUpdate, CanDelete: $canDelete}) {
        returning {
            Id
            AziendaId
            Area
            CanRead
            CanCreate
            CanUpdate
            CanDelete
        }
    }
}`;
export const mutation_update_user_permission_allRead = `
mutation updateUserPermissionAllRead($userId: String!, $aziendaId: Int!, $canRead: Boolean!) {
    update_user_permission(where: {UserId: {_eq: $userId}, AziendaId: {_eq: $aziendaId}}, _set: {CanRead: $canRead}) {
        returning {
            Id
            AziendaId
            Area
            CanRead
            CanCreate
            CanUpdate
            CanDelete
        }
    }
}`;
export const mutation_update_user_permission_allCreate = `
mutation updateUserPermissionAllCreate($userId: String!, $aziendaId: Int!, $canCreate: Boolean!) {
    update_user_permission(where: {UserId: {_eq: $userId}, AziendaId: {_eq: $aziendaId}}, _set: {CanCreate: $canCreate}) {
        returning {
            Id
            AziendaId
            Area
            CanRead
            CanCreate
            CanUpdate
            CanDelete
        }
    }
}`;
export const mutation_update_user_permission_allUpdate = `
mutation updateUserPermissionAllUpdate($userId: String!, $aziendaId: Int!, $canUpdate: Boolean!) {
    update_user_permission(where: {UserId: {_eq: $userId}, AziendaId: {_eq: $aziendaId}}, _set: {CanUpdate: $canUpdate}) {
        returning {
            Id
            AziendaId
            Area
            CanRead
            CanCreate
            CanUpdate
            CanDelete
        }
    }
}`;
export const mutation_update_user_permission_allDelete = `
mutation updateUserPermissionAllDelete($userId: String!, $aziendaId: Int!, $canDelete: Boolean!) {
    update_user_permission(where: {UserId: {_eq: $userId}, AziendaId: {_eq: $aziendaId}}, _set: {CanDelete: $canDelete}) {
        returning {
            Id
            AziendaId
            Area
            CanRead
            CanCreate
            CanUpdate
            CanDelete
        }
    }
}`;